const MetaService = {
  robotIndex: () => {
    return {
      name: "robots",
      Name: "robots",
      content:
        "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    };
  },
  robotNoIndex: () => {
    return {
      name: "robots",
      Name: "robots",
      content: "noindex, nofollow",
    };
  },
  description: (description: String | null) => {
    return description !== null
      ? {
          name: "description",
          Name: "description",
          content: description,
        }
      : {};
  },
  keywords: (keywords: String | null) => {
    return keywords !== null
      ? {
          name: "keywords",
          Name: "keywords",
          content: keywords,
        }
      : {};
  },
  clearDefaultCanonical: () => {
    document //canonical and alternate link tags
      .querySelector('head link[rel="canonical"]')
      ?.remove();
    document
      .querySelector('head link[rel="alternate"][hreflang="es"]')
      ?.remove();
    document
      .querySelector('head link[rel="alternate"][hreflang="en"]')
      ?.remove();
    document
      .querySelector('head link[rel="alternate"][hreflang="x-default"]')
      ?.remove();
  },
  setKnowledgeContent(content: string){
    const knowledgeElement = document.querySelector("head #knowledge");
    if (knowledgeElement !== null) {
      knowledgeElement.textContent = content;
    }
  },
  canonicalLinks: (path: null | string = null) => {
    const currentUrl = `${import.meta.env.VITE_CLOUD_HOST}${path ?? ""}`;
    return [
      {
        rel: "canonical",
        href: currentUrl,
      },
      {
        rel: "alternate",
        href: `${currentUrl.replace(/\/(en|es)\//, "/es/")}`,
        hreflang: "es",
      },
      {
        rel: "alternate",
        href: `${currentUrl.replace(/\/(en|es)\//, "/en/")}`,
        hreflang: "en",
      },
      {
        rel: "alternate",
        href: `${currentUrl.replace(/\/(en|es)\//, "/es/")}`,
        hreflang: "x-default",
      },
    ];
  },
  updateTitle: (title: string) => {
    const titleEl = document.querySelector("head title");
    if (titleEl !== null) {
      titleEl.textContent = title;
    }
  },
  updateDescription: (description: string) => {
    const descEl = document.querySelector('head meta[name="description"]');
    if (descEl !== null) {
      descEl.setAttribute("content", description);
    }
  },
  updateCanonical: (
    path: string,
    localizedPaths: any = null,
    xDefault: string = "es"
  ) => {
    if (null !== localizedPaths) {
      const canonicalLinks = MetaService.canonicalLinks();
      canonicalLinks.forEach((value) => {
        const linkEl = document.createElement("link");
        linkEl.setAttribute("rel", value.rel);
        if (value.rel === "canonical") {
          linkEl.setAttribute("href", value.href + path);
        } else if (value.hreflang !== undefined) {
          if ("x-default" !== value.hreflang) {
            linkEl.setAttribute(
              "href",
              value.href + `${localizedPaths[value.hreflang]}`
            );
          } else {
            linkEl.setAttribute(
              "href",
              value.href + `${localizedPaths[xDefault]}`
            );
          }
          linkEl.setAttribute("hreflang", value.hreflang);
        }
        document.querySelector("head")?.appendChild(linkEl);
      });
    } else {
      const canonicalLinks = MetaService.canonicalLinks(path);
      canonicalLinks.forEach((value) => {
        const linkEl = document.createElement("link");
        linkEl.setAttribute("rel", value.rel);
        linkEl.setAttribute("href", value.href);
        if (value.hreflang !== undefined) {
          linkEl.setAttribute("hreflang", value.hreflang);
        }
        document.querySelector("head")?.appendChild(linkEl);
      });
    }
  },
  updateHtmlLang: (lang: string) => {
    document.documentElement.setAttribute("lang", lang);
  },
  updateRobots: (index: boolean = true) => {
    let robotEl = document.querySelector('head meta[name="robots"]');
    if (robotEl === null) {
      robotEl = document.createElement("meta");
      robotEl.setAttribute("name", "robots");
      document.querySelector("head")?.appendChild(robotEl);
    }
    robotEl.setAttribute(
      "content",
      !index
        ? "noindex, nofollow"
        : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    );
  },
};

export default MetaService;
